import { useRef } from 'react';
import useContextWithErrorHandler from '@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { TelemetryContext } from '../providers/BaseTelemetryProvider';
import { UseTelemetry } from '../providers/BaseTelemetryProvider/types';
import { TelemetryEvents } from '../types';

export type UseTelemetryPartialDispatch = {
  setTelemetryEventData: (data: any, clearPreviousData?: boolean) => void;
  clearTelemetryEventData: () => void;
  fireEvent: (data?: any, force?: boolean, clearPreviousData?: boolean) => void;
};
type TUseTelemetry = [
  {
    eventData: {
      [key: string]: any;
    };
    eventAlreadyFired: boolean;
  },
  UseTelemetryPartialDispatch
];
const useTelemetry = (TelemetryEvent: TelemetryEvents): TUseTelemetry => {
  const eventWasCreatedRef = useRef(false);
  const [state, dispatch] = useContextWithErrorHandler<UseTelemetry>(
    TelemetryContext,
    'TelemetryProvider'
  );

  const fireEvent = (data?: any, force = true, clearPreviousData = true) => {
    if (force || !eventWasCreatedRef.current) {
      dispatch.fireEvent(TelemetryEvent)(data, clearPreviousData);
      eventWasCreatedRef.current = true;
    }
  };

  return [
    { eventData: { ...state.data[TelemetryEvent] }, eventAlreadyFired: eventWasCreatedRef.current },
    {
      clearTelemetryEventData: dispatch.clearTelemetryEventData(TelemetryEvent),
      setTelemetryEventData: dispatch.setTelemetryEventData(TelemetryEvent),
      fireEvent: fireEvent,
    },
  ];
};

export default useTelemetry;
